export default {
  refresh: 'Osveži',
  networkError: 'Težava z omrežjem...',
  tryRefresh: 'Poskusite osvežiti stran.',

  'colors.roof': 'Streha',
  'colors.roof.cover': 'Kritina',
  'colors.roof.supportColumns': 'Podporni stebri',

  'colors.facade': 'Fasada',
  'colors.facade.finish1': 'Zaključni sloj 1',
  'colors.facade.finish2': 'Zaključni sloj 2',
  'colors.facade.finish3': 'Zaključni sloj 3',

  'colors.windowsAndDoors': 'Okna in vrata',
  'colors.windowsAndDoors.windowsOutside': 'Okna - zunaj',
  'colors.windowsAndDoors.windowsInside': 'Okna - znotraj',
  'colors.windowsAndDoors.blinders.bars': 'Žaluzije - lamele',
  'colors.windowsAndDoors.blinders.guides': 'Žaluzije - vodila',
  'colors.windowsAndDoors.frontDoor.outside': 'Vhodna vrata - zunaj',
  'colors.windowsAndDoors.frontDoor.inside': 'Vhodna vrata - znotraj',
  'colors.windowsAndDoors.innerDoors': 'Notranja vrata',

  'colors.floors': 'Talne obloge',
  'colors.floors.parquet.type': 'Tip parketa',

  'settings.notifications.title': 'Omogočite obvestila',
  'settings.notifications.help': 'Bodite obveščeni o spremembah na projektu.',
  'settings.notifications.error.fetch.line1': 'Nastavitev trenutno ni mogoče pridobiti!',
  'settings.notifications.error.fetch.line2': 'Administratorji so bili obveščeni.',
  'settings.notifications.warning.noBrowserPermissions':
    'V brskalniku morate omogočiti dovoljenje za obvestila!',
  'settings.notifications.error.change.line1': 'Nastavitve ni bilo možno spremeniti.',
  'settings.notifications.error.change.line2': 'Administratorji so bili obveščeni.',
  'settings.version': 'Verzija',
  'settings.user': 'Prijavljeni kot',

  'task.week': 'teden',

  'activity.confirmed': 'Potrjeno',
  'activity.planned': 'Planirano',
  'activity.inProgress': 'V teku',
  'activity.completed': 'Zaključeno',

  'contacts.roles.cx_lead': 'Vodja CX',
  'contacts.roles.engineering': 'Vodja izvedbe',
  'contacts.roles.site_manager': 'Vodja gradbišča',
  'contacts.title': 'Kontakti',
  'contacts.lumarContacts': 'Kontakti Lumar',
  'contacts.samplingContacts': 'Kontakti za vzorčenje',

  'stageInfo.daysToMove': 'dni do vselitve',
  'stageInfo.phase': 'Faza',
  'stageInfo.phase.1': 'Upravni postopki in projektiranje',
  'stageInfo.phase.2': 'Tehnična priprava in proizvodnja',
  'stageInfo.phase.3': 'Izvedba',
  'stageInfo.phase.4': 'Vzdrževanje',

  'home.lumarActivities': 'Lumar aktivnosti',
  'home.showMore': 'Prikaži več',
  'home.buildingAdvice': 'Nasveti za gradnjo',

  'lumarActivities.activities': 'Lumar aktivnosti',
  'lumarActivities.currentActivities': 'Trenutne aktivnosti',
  'lumarActivities.pastActivities': 'Pretekle aktivnosti',
  'lumarActivities.loadingActivities': 'Nalaganje aktivnosti...',
  'lumarActivities.noCurrentActivities': 'Trenutno ni planiranih aktivnosti!',

  'recommendUs.title': 'Priporočajte nas',
  'recommendUs.hint':
    'Vpišite e-poštni naslov svojega prijatelja, z njim delite naše storitve in si za uspešno priporočilo prislužite brezplačni letni servisni pregled hiše.',
  'recommendUs.enterEmail': 'Vpišite e-poštni naslov',
  'recommendUs.recommend': 'PRIPOROČI',
  'recommendUs.errors.invalidEmail': 'E-mail naslov ni veljaven!',
  'recommendUs.errors.requiredEmail': 'E-mail naslov je obvezen!',
  'recommendUs.errors.sendingFailed': 'Priporočila ni bilo možno poslati!',
  'recommendUs.errors.sendingFailed.network':
    'Priporočila ni bilo možno poslati. Preverite internetno povezavo.',
  'recommendUs.sent': 'Priporočilo poslano!'
};
